import React from 'react';
import { DefaultTheme } from 'styled-components';

interface Props {
  theme?: DefaultTheme;
}

const IllustrationMobility: React.FC<React.PropsWithChildren<Props>> = ({
  theme,
  ...otherProps
}) => {
  return (
    <svg
      width="304"
      height="304"
      fill="none"
      viewBox="0 0 304 304"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path stroke={theme ? theme.primary[500] : '#C0C2C9'} d="M0 303.5h304" />
      <path
        d="m280.092 58.164-1.684-2.769c-14.173-23.332-39.798-37.399-66.823-35.69a71.66 71.66 0 0 0-10.364 1.416c-24.562 5.254-45.938 23.811-54.8 47.577-5.182 13.976-6.665 30.075-16.556 41.165-12.871 14.442-34.72 14.882-53.926 14.293-19.205-.589-41.074-.084-53.88 14.41-8.019 9.058-10.571 21.999-9.923 34.144 1.73 32.203 24.16 60.983 52.74 75.29 28.579 14.306 62.184 15.587 93.432 9.297 43.814-8.819 85.419-33.031 110.448-70.423 25.029-37.393 31.358-88.34 11.336-128.71Z"
        fill="#F0F1F3"
      />
      <circle cx={95.837} cy={79.283} r={26.006} fill="#F0F1F3" />
      <circle cx={267.287} cy={241.1} fill="#F0F1F3" r={20.227} />
      <circle cx={34.675} cy={262.772} fill="#F0F1F3" r={22.635} />
      <path
        d="m260.27 302.45-101.251-.063a22.049 22.049 0 0 1-22.068-22.062l.048-253.808A22.05 22.05 0 0 1 159.068 4.47l101.3.022a22.067 22.067 0 0 1 22.041 22.061l-.049 253.808a22.054 22.054 0 0 1-6.462 15.628 22.061 22.061 0 0 1-15.628 6.462Z"
        fill="#222"
      />
      <path
        d="m260.972 12.05-19.698-.091a4.883 4.883 0 0 0-4.804 4.978v3.577a4.874 4.874 0 0 1-1.368 3.488 4.872 4.872 0 0 1-3.436 1.49l-38.399-.18a4.879 4.879 0 0 1-4.763-5.02V16.72a4.876 4.876 0 0 0-4.769-5.027h-6.924l-17.243-.084a15.509 15.509 0 0 0-15.571 15.438l-1.052 248.62a15.509 15.509 0 0 0 15.43 15.57l101.398.467a15.505 15.505 0 0 0 15.57-15.438l1.06-248.648a15.508 15.508 0 0 0-15.431-15.57Z"
        fill="#F7F8FB"
      />
      <path
        d="M217.947 244.695c-.118 2.998-.23 5.815-.32 8.158h14.566l-1.806-8.946-12.44.788ZM158.747 248.439l.126 4.414h57.295c.098-2.483.209-5.23.314-8.068l-57.735 3.654ZM231.137 243.858l1.792 8.995h26.852l-.321-10.787-28.323 1.792Z"
        fill="#F7F8FB"
      />
      <path
        d="m219.397 118.146 5.077-29.439-13.298-.983v30.422h8.221Z"
        fill="#F0F1F3"
      />
      <path
        d="m157.549 232.095-14.434 5.655-.042 10.222 14.908-.942-.432-14.935Z"
        fill="#F7F8FB"
      />
      <path
        d="m157.487 229.794-.788-27.417h-.014v-9.671l-13.381 1.416-.174 41.278 14.35-5.62.007.014Z"
        fill="#F0F1F3"
      />
      <path
        d="m156.682 171.118-13.276-1.75-.097 22.564 13.373-1.416v-19.398ZM255.648 193.117l-.557 7.858-15.682 1.688 1.213 6.22 17.802-1.346-.265-8.911 1.422-5.906-3.933.397ZM227.386 209.88l12.502-.942-2.719-13.959-10.919 1.102 1.136 13.799Z"
        fill="#F7F8FB"
      />
      <path
        d="m227.506 211.33.955 11.638 1.695 15.96.697 3.493 28.567-1.805-.955-31.622-30.959 2.336Z"
        fill="#F0F1F3"
      />
      <path
        d="m178.342 156.385 1.101 1.882-22.033 12.872v30.478l23.254-1.646 44.841-4.539-1.638-19.984-42.813-5.578.286-2.161 42.311 5.522-2.789-33.818-41.907 4.03-.139-1.443 41.927-4.03-1.443-17.648h-40.31l-35.4 6.443-.175 40.407 13.409 1.764 21.518-12.551Zm-18.673 42.303s.167-25.101 0-26.071l17.975-9.559 2.329 34.347-20.304 1.283ZM254.182 193.264l-16.288 1.645 1.234 6.325 14.601-1.576.453-6.394ZM218.146 239.312 218 243.23l12.118-.767-.62-3.124-11.352-.027Z"
        fill="#F7F8FB"
      />
      <path
        d="m192.042 118.147 2.133-9.686h16.275V87.669l-50.887-3.772v19.53l-15.898 3.591-.07 17.53 35.199-6.401h13.248Z"
        fill="#F0F1F3"
      />
      <path
        d="m225.991 60.272-.432-1.785 19.433-7.67L232.35 25.41a4.61 4.61 0 0 1-.697.056l-21.49-.056.586 35.505 15.242-.642Z"
        fill="#F7F8FB"
      />
      <path
        d="M255.445 46.669v-34.64l-14.141-.07a4.881 4.881 0 0 0-4.804 4.978v3.577a5.072 5.072 0 0 1-2.092 4.1l12.648 25.388 8.389-3.333Z"
        fill="#F0F1F3"
      />
      <path
        d="m182.391 48.161-1.639-36.481h-3.932l-15.34-.07-6.575 32.625 27.486 3.926Zm-3.486-32.772.523 29.704-20.43-2.991 4.448-26.72 15.459.007ZM183.138 48.266v.306c.035 2.852.098 7.97.14 13.45l26.761-1.094-.572-35.52-16.197-.076a4.875 4.875 0 0 1-3.425-1.52 4.895 4.895 0 0 1-1.338-3.5v-3.57a4.892 4.892 0 0 0-2.901-4.61 4.882 4.882 0 0 0-1.868-.418h-2.259l1.638 36.58.021-.028ZM152.743 43.9l6.52-32.297a15.49 15.49 0 0 0-15.222 15.417l-.118 16.1.069-.474 8.751 1.255ZM157.381 83.736l-13.61-1.004-.091 22.048 13.701-3.096V83.736ZM152.595 44.619l-8.66-1.248-.147 35.714 1.862.14 6.945-34.606ZM180.092 229.376l.231-28.672-22.899 1.624.809 28.086 21.859-1.038ZM184.301 222.737l32.43 15.536c.391-10.153.732-19.643.698-20.221h.697l.348-.698c.461.23.461.23.217 7.147-.133 3.863-.328 9.002-.523 14.141h11.219l-1.66-15.584-2.224-26.901-42.346 4.268 1.144 22.312ZM263.799 175.177l-.369-3.78-38.874 4.038 1.639 19.921 33.56-3.382 4.044-16.797ZM210.451 110.644h-14.525l-1.652 7.502h16.177v-7.502ZM257.796 113.175l-36.37-2.517-1.499 8.597 1.527 18.645 38.35-3.688-2.008-21.037Zm-35.031 6.059 1.952-5.418 31.587 1.995 1.826 15.514-34.298 4.065-1.067-16.156ZM261.567 152.152l-1.597-16.497-38.378 3.695 1.444 17.551 38.531-4.749ZM158.022 248.481l-14.887.941-.063-.969-.021 4.4h15.096l-.125-4.372Z"
        fill="#F7F8FB"
      />
      <path
        d="m276.139 38.483.216.55.049-11.414a15.495 15.495 0 0 0-4.491-10.98 15.494 15.494 0 0 0-10.94-4.59h-4.825v34.355l19.991-7.921Z"
        fill="#F0F1F3"
      />
      <path
        d="m216.705 239.089-33.106-15.856-1.165-22.732-1.394.14-.237 29.432-22.557 1.067v.655l.439 15.173 57.839-3.654c.07-1.394.126-2.817.181-4.225Zm-57.037-6.074 31.58-2.217 20.549 9.532-52.129 2.789v-10.104ZM266.725 76.638l1.395-8.033c-11.854-4.24-12.698-16.616-12.663-20.36l-7.747 3.06 11.666 23.422 7.349 1.91ZM224.383 173.266l16.135-1.681-3.18-14.252-14.12 1.736 1.165 14.197ZM259.197 90.611h-30.143l-2.503-.188-3.403 19.74 35.777 2.475-.829-8.583 3.521-12.677-2.42-.767ZM257.114 85.319l.376-9.42-11.853-23.784-18.367 7.265 6.311 25.939h23.533Zm-12.182-30.31 10.857 20.653-1.569 6.435-18.582-.697-4.644-19.523 13.938-6.869ZM261.804 199.002l.558 18.506 13.06-.739.035.732-13.074.732.662 22.153 12.349-.781.09 1.45-12.397.781.335 11.017h12.028l.265-61.765-12.307 1.242-1.604 6.672Z"
        fill="#F7F8FB"
      />
      <path
        d="m182.422 48.893-27.66-3.96-6.917 34.459 34.696 2.573c.139-5.313.021-21.588-.119-33.072Z"
        fill="#F0F1F3"
      />
      <path
        d="M227.908 85.319h4.183l-5.926-24.321-15.389.627.369 22.452 16.763 1.242ZM183.25 82.007l27.193 2.015-.39-22.355-26.769 1.095c.056 7.551.077 15.64-.034 19.245ZM261.778 154.321l-23.714 2.921 3.186 14.267 21.971-2.287-1.443-14.901Z"
        fill="#F7F8FB"
      />
      <path
        d="m268.204 67.873 1.52-8.995 6.547.51.084-19.413-20.221 7.99c-.384 13.646 8.193 18.45 12.07 19.908Z"
        fill="#F0F1F3"
      />
      <path
        d="m260.432 102.716.823 8.513 14.796 1.025.07-17.536-12.384-3.912-3.305 11.91ZM267.475 175.435l-3.884 16.148 12.119-1.22.076-16.944c-3.723-.976-6.973-1.778-8.723-2.091l.412 4.107ZM259.289 85.59l16.853 5.328.035-9.588-16.553-4.274-.335 8.535ZM266.861 169.089c1.395.203 3.933.753 8.939 2.092l.154-37.032-12.363 1.185 3.27 33.755ZM263.442 133.863l12.516-1.207.077-18.219-14.566-1.004 1.973 20.43ZM269.599 68.333c2.378.697 4.582 1.283 6.625 1.695l.041-9.198-5.327-.418-1.339 7.921ZM268.142 77.007l8.046 2.092v-8.311a71.673 71.673 0 0 1-6.743-1.716l-1.303 7.935Z"
        fill="#F7F8FB"
      />
      <path
        d="m275.485 241.055-.09-1.451-12.349.781-.697-22.152 13.074-.732v-.697l-13.067.732-.551-18.506 1.604-6.673 12.299-1.269v-.697l-12.125 1.22 3.884-16.149-.405-4.128c1.75.335 5 1.137 8.723 2.092v-2.287c-5.006-1.311-7.579-1.862-8.939-2.092l-3.27-33.783 12.363-1.185v-1.464l-12.509 1.206-1.981-20.43 14.566 1.004v-2.183l-14.796-1.025-.823-8.513 3.305-11.91 12.384 3.912v-3.8l-16.853-5.327.342-8.535 16.546 4.274v-2.245l-8.047-2.092 1.339-7.942a72.16 72.16 0 0 0 6.743 1.716v-.69a70.337 70.337 0 0 1-6.624-1.695l1.338-7.921 5.328.418V59.38l-6.548-.509-1.52 9.009c-3.877-1.457-12.453-6.276-12.042-19.921l20.221-7.991v-.935l-.216-.55-19.907 7.9V12.028h-.767v34.64l-8.416 3.334-12.621-25.388a4.65 4.65 0 0 1-2.029.795l12.676 25.401-19.433 7.67.433 1.786-15.229.62-.634-35.477h-.698l.586 35.56-26.761 1.096c-.042-5.481-.105-10.6-.14-13.45v-.308l-1.638-36.579h-.732l1.638 36.482-27.514-3.975 6.547-32.618H159.229l-6.485 32.297-8.737-1.255-.069.474v.252l8.66 1.248-6.973 34.605-1.869-.14v3.64l13.611 1.012v17.948l-13.701 3.095v2.197l15.891-3.591V83.875l50.901 3.772v20.793h-16.282l-2.14 9.706h-13.249l-35.198 6.401v2.218l35.401-6.443h40.316l1.443 17.648-41.927 4.03.14 1.443 41.906-4.03 2.789 33.818-42.345-5.536-.286 2.161 42.812 5.578 1.667 19.998-44.807 4.519-23.254 1.645v-30.457l22.034-12.851-1.102-1.882-21.518 12.551-13.408-1.764v2.196l13.248 1.75v19.398l-13.374 1.395v2.217l13.381-1.394v9.622l.788 27.417-14.35 5.62v2.35l14.433-5.655.433 14.935-14.908.942v.481l.063.969 14.886-.941.126 4.372h.697l-.125-4.414 57.734-3.654c-.105 2.838-.216 5.578-.314 8.068h1.458c.09-2.343.202-5.16.32-8.158l12.44-.802 1.785 8.946h.739l-1.792-8.995 28.323-1.792.321 10.787h3.64l12.083-11.798Zm-57.504 2.175.147-3.918h11.351l.621 3.123-12.119.795Zm12.851-.809-.697-3.486-1.695-15.961-.955-11.637 30.966-2.336.948 31.621-28.567 1.799Zm7.042-47.512 16.289-1.645-.453 6.394-14.601 1.575-1.235-6.324Zm-.697.07 2.719 13.945-12.502.942-1.136-13.799 10.919-1.088Zm21.253 12.551-17.801 1.346-1.214-6.22 15.682-1.687.558-7.859 3.933-.397-1.395 5.906.237 8.911Zm-21.072-50.197 3.18 14.252-16.135 1.681-1.171-14.197 14.126-1.736Zm3.912 14.176-3.214-14.267 23.707-2.921 1.443 14.901-21.936 2.287Zm16.309-60.531-35.777-2.475 3.403-19.74 2.503.181h30.143l2.42.76-3.521 12.684.829 8.59Zm-2.154-62.754c0 3.744.788 16.12 12.662 20.36l-1.394 8.033-7.384-1.91-11.631-23.401 7.747-3.082Zm-9.762 3.87 11.854 23.783-.377 9.42h-23.554l-6.31-25.938 18.387-7.266Zm-19.461 8.876 5.927 24.32h-4.184l-16.734-1.24-.37-22.453 15.361-.627Zm-16.114.662.37 22.362-27.194-2.015c.111-3.626.091-11.694.035-19.252l26.789-1.095Zm-55.294-16.734 27.661 3.967c.14 11.484.258 27.759.119 33.065l-34.697-2.573 6.917-34.46Zm69.728 43.782-5.125 29.466h-8.221V87.724l13.346.956Zm-28.547 21.936h14.524v7.53h-16.176l1.652-7.53Zm23.952 8.639 1.478-8.597 36.37 2.517 2.057 21.009-38.351 3.688-1.554-18.617Zm40.023 16.4 1.597 16.497-38.532 4.749-1.443-17.551 38.378-3.695Zm-35.414 39.779 38.873-4.037.369 3.779-4.044 16.798-33.532 3.381-1.666-19.921Zm3.179 47.596 1.66 15.584h-11.199c.196-5.139.391-10.277.523-14.14.244-6.917.244-6.917-.216-7.147l-.348.697h-.698c.035.606-.307 10.096-.697 20.221l-32.437-15.508-1.144-22.312 42.346-4.268 2.21 26.873ZM180.3 200.717l-.23 28.672-21.838 1.018-.809-28.086 22.877-1.604Zm-22.033 31.085v-.655l22.556-1.067.238-29.432 1.394-.14 1.164 22.731 33.107 15.856a797.698 797.698 0 0 0-.16 4.24l-57.839 3.654-.46-15.187Z"
        fill="#fff"
      />
      <path
        d="m191.248 230.798-31.579 2.218v10.131l52.128-2.817-20.549-9.532ZM256.303 115.811l-31.587-1.995-1.952 5.418 1.067 16.156 34.298-4.065-1.826-15.514ZM180.034 46.983l-.522-29.704h-15.431l-4.477 26.712 20.43 2.992Z"
        fill="#E9EAEC"
      />
      <path
        d="m254.219 82.097 1.561-6.435-10.849-20.654-13.932 6.854 4.637 19.531 18.583.704Z"
        fill="#F0F1F3"
      />
      <path
        d="M159.669 172.617c.167.942 0 26.071 0 26.071l20.304-1.283-2.329-34.347-17.975 9.559ZM227.395 193.027l-1.081-15.577 34.829-4.477v2.692l-4.212 14.322-29.536 3.04Z"
        fill="#E9EAEC"
      />
      <path
        d="m259.86 232.709-.439-10.16-30.61 1.486a4.574 4.574 0 0 1-2.315-.488l-43.426-21.93a3.164 3.164 0 0 1-1.723-2.649l-5.906-114.625a1.89 1.89 0 0 1 1.254-1.897c.255-.093.526-.13.796-.111l18.611 1.394V63.37h2.21V83.98a1.915 1.915 0 0 1-.615 1.4 1.918 1.918 0 0 1-1.442.51l-18.596-1.394 5.899 114.353a.963.963 0 0 0 .523.816l43.426 21.929a2.4 2.4 0 0 0 1.22.258l30.869-1.499a1.935 1.935 0 0 1 2.022 1.841l.446 10.41-2.204.105Z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M177.81 119.604h42.422l1.855-9.901 22.756-.683 15.09 3.66 1.164 20.535-40.002 4.372 2.845 36.739 1.875 20.716-17.913 1.813-47.596 4.428 4.184 90.136h.349l-3.807-89.502 46.94-4.372 18.596-1.876-1.931-21.399-2.789-36.063 39.989-4.372-1.235-21.713-15.653-3.793-.085.344-.011-.351-23.345.704-1.855 9.881h-41.16l-.523-34.655-7.802-1.799v-5.397h-.697v5.948l7.816 1.806.523 34.794Z"
        fill={theme ? theme.primary[500] : '#888D9B'}
      />
      <path
        d="M183.248 58.18a13.179 13.179 0 0 0-5.175-10.466 13.171 13.171 0 0 0-19.348 17.147v.049c.502.85 1.136 1.464 1.778 2.363l7.67 10.16a2.372 2.372 0 0 0 3.8 0l7.51-10.02a28.152 28.152 0 0 0 1.917-2.545v-.035a13.246 13.246 0 0 0 1.848-6.652Z"
        fill={theme ? theme.primary[500] : '#888D9B'}
      />
      <path
        d="M170.08 65.572a7.398 7.398 0 1 1 7.37-7.391 7.389 7.389 0 0 1-7.37 7.391Z"
        fill={theme ? theme.primary[200] : '#A4A8B2'}
      />
      <g filter="url(#a)">
        <path
          d="M174.974 109.861h-60.999a8.607 8.607 0 0 0-3.303.655 8.608 8.608 0 0 0-4.671 4.671 8.606 8.606 0 0 0-.654 3.303v44.566a8.63 8.63 0 0 0 8.628 8.639h46.302l12.27 9.349v-9.349h2.427a8.64 8.64 0 0 0 8.639-8.639V118.49a8.63 8.63 0 0 0-8.639-8.629Z"
          fill="#fff"
        />
      </g>
      <g
        clipPath="url(#b)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      >
        <path d="M133.188 155.951h22.574a1.13 1.13 0 0 0 0-2.258h-22.574a1.13 1.13 0 0 0 0 2.258Z" />
        <path d="M119.644 153.693h4.514a1.13 1.13 0 0 1 0 2.258h-5.643a1.13 1.13 0 0 1-1.129-1.129V129.99a4.515 4.515 0 0 1 4.515-4.514h41.796a7.867 7.867 0 0 1 7.867 7.867v21.479c0 .623-.505 1.129-1.128 1.129h-5.644a1.13 1.13 0 0 1 0-2.258h4.515v-20.35a5.61 5.61 0 0 0-5.61-5.61h-41.796a2.256 2.256 0 0 0-2.257 2.257v23.703Z" />
        <path d="M128.673 149.179a5.645 5.645 0 0 0-5.643 5.643 5.645 5.645 0 0 0 5.643 5.644 5.645 5.645 0 0 0 5.644-5.644 5.645 5.645 0 0 0-5.644-5.643Zm0 2.257a3.388 3.388 0 0 1 3.387 3.386 3.388 3.388 0 0 1-6.773 0 3.387 3.387 0 0 1 3.386-3.386ZM160.277 149.179a5.645 5.645 0 0 0-5.643 5.643 5.645 5.645 0 0 0 5.643 5.644 5.646 5.646 0 0 0 5.644-5.644 5.646 5.646 0 0 0-5.644-5.643Zm0 2.257a3.387 3.387 0 0 1 3.386 3.386 3.387 3.387 0 0 1-3.386 3.386 3.387 3.387 0 0 1-3.386-3.386 3.387 3.387 0 0 1 3.386-3.386ZM160.277 126.604v11.287c0 1.796.714 3.519 1.984 4.79a6.777 6.777 0 0 0 4.789 1.983 1.129 1.129 0 0 0 0-2.258 4.507 4.507 0 0 1-3.192-1.323 4.507 4.507 0 0 1-1.323-3.192v-11.287a1.129 1.129 0 0 0-2.258 0ZM118.515 139.02h18.059a1.13 1.13 0 0 0 0-2.257h-18.059a1.129 1.129 0 1 0 0 2.257Z" />
        <path d="M152.376 139.02h9.03a1.13 1.13 0 0 0 0-2.257h-9.03a1.128 1.128 0 1 0 0 2.257ZM124.159 148.05h1.128a1.13 1.13 0 0 0 0-2.258h-1.128a1.13 1.13 0 0 0 0 2.258ZM126.416 126.604v11.287a1.13 1.13 0 0 0 2.257 0v-11.287a1.128 1.128 0 1 0-2.257 0ZM143.347 126.604v21.446a1.129 1.129 0 1 0 2.257 0v-21.446a1.129 1.129 0 0 0-2.257 0Z" />
        <path d="M153.505 126.604c0-.623-.506-1.128-1.129-1.128h-15.802c-.623 0-1.129.505-1.129 1.128v21.446a1.13 1.13 0 0 0 1.129 1.129h15.802a1.13 1.13 0 0 0 1.129-1.129v-21.446Zm-15.802 1.129v19.188h13.544v-19.188h-13.544Z" />
      </g>
      <g filter="url(#c)">
        <path
          d="M99.983 203.168h39.266a11.26 11.26 0 0 1 7.956 3.298 11.258 11.258 0 0 1 3.29 7.958v26.266a11.238 11.238 0 0 1-3.287 7.964 11.25 11.25 0 0 1-7.959 3.3h-1.602v7.387l-9.682-7.387H99.983a11.254 11.254 0 0 1-11.255-11.255v-26.266a11.254 11.254 0 0 1 11.255-11.265Z"
          fill="#fff"
        />
      </g>
      <g clipPath="url(#d)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M114.932 217.068c-.421-.045-1.052-.025-2.054.152-1.37.243-1.524.119-2.391-.112a.615.615 0 0 0-.754.441.617.617 0 0 0 .44.755 6.36 6.36 0 0 0 1.622.217.596.596 0 0 0 .048.208l.337.771 1.252 4.085-1.798 2.455a6.959 6.959 0 0 0-3.796-1.132c-3.861 0-7.006 3.14-7.006 6.999 0 3.858 3.145 6.998 7.006 6.998 3.406 0 6.246-2.441 6.87-5.666l.112.009a2.12 2.12 0 0 0 2.111 2.086c1.161 0 2.11-.949 2.11-2.111 0-.281-.059-.548-.16-.794l8.539-7.512.378 1.083c-2 1.236-3.347 3.439-3.347 5.955a7.005 7.005 0 0 0 6.998 6.999c3.861 0 7.006-3.14 7.006-6.999 0-3.858-3.145-7.006-7.006-7.006-.897 0-1.748.188-2.536.498l-1.926-5.498 1.95.057a.617.617 0 0 0 .53-.963l-.723-1.06a.615.615 0 0 0-.859-.16.614.614 0 0 0-.16.858l.041.056-1.549-.047a.616.616 0 0 0-.635.593v.048a.625.625 0 0 0 .009.361l.538 1.541-12.216-.28-.569-1.887-.281-.634c.013-.002.018.003.032 0 .923-.163 1.451-.164 1.709-.136.129.014.189.036.201.04a.616.616 0 0 0 .682-1.019s-.143-.1-.265-.144a2.05 2.05 0 0 0-.489-.105h-.001Zm-.633 5.128 12.263.273.425 1.22a.616.616 0 0 0-.129.08l-8.787 7.721a2.058 2.058 0 0 0-.875-.33l-2.311-7.038-.586-1.926Zm-.41 2.849 2.079 6.324c-.302.16-.543.395-.739.674l-.393-.032c.001-.035.009-.069.009-.104 0-2.019-.873-3.826-2.248-5.104l1.292-1.758Zm-6.051 1.092a5.72 5.72 0 0 1 3.066.899l-3.483 4.751a.615.615 0 0 0 .457.978l5.586.386a5.747 5.747 0 0 1-5.626 4.518 5.754 5.754 0 0 1-5.77-5.762 5.761 5.761 0 0 1 5.77-5.77Zm23.611.048a5.768 5.768 0 0 1 5.778 5.77 5.761 5.761 0 0 1-5.778 5.762 5.755 5.755 0 0 1-5.771-5.762 5.756 5.756 0 0 1 2.537-4.775l.762 2.183 2.223 3.282a.616.616 0 0 0 1.019-.69l-2.135-3.154-.77-2.199a5.759 5.759 0 0 1 2.135-.417Zm-19.566 1.605a5.751 5.751 0 0 1 1.726 4.117v.025l-4.535-.314 2.809-3.828Zm5.048 4.55c.496 0 .883.389.883.883a.867.867 0 0 1-.883.875.874.874 0 0 1-.891-.875.88.88 0 0 1 .891-.883Z"
          fill={theme ? theme.primary[500] : '#C0C2C9'}
        />
      </g>
      <g filter="url(#e)">
        <path
          d="M16.57 138.456h46.985a9.039 9.039 0 0 1 9.037 9.036v33.34a9.034 9.034 0 0 1-9.037 9.036h-.16v7.785l-10.204-7.785h-36.62a9.048 9.048 0 0 1-9.046-9.036v-33.34a9.037 9.037 0 0 1 9.046-9.036Z"
          fill="#fff"
        />
      </g>
      <g
        clipPath="url(#f)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      >
        <path d="M20.429 161.768h29.215a8.963 8.963 0 0 1 8.765 7.088 2.714 2.714 0 0 1-2.653 3.282H20.429a.864.864 0 0 0 0 1.729h35.327a4.44 4.44 0 0 0 4.343-5.373v-.003a10.69 10.69 0 0 0-10.455-8.451H20.43a.864.864 0 0 0 0 1.728Z" />
        <path d="M51.54 161.768v3.138c0 1.231.489 2.41 1.36 3.28.87.871 2.049 1.36 3.28 1.36h.546a.865.865 0 0 0 0-1.729h-.547a2.908 2.908 0 0 1-2.91-2.911v-3.138a.864.864 0 0 0-1.73 0ZM20.429 176.459h38.888a.864.864 0 0 0 0-1.728H20.43a.864.864 0 0 0 0 1.728ZM48.083 166.953a2.593 2.593 0 0 1-2.593 2.593H20.43a.865.865 0 0 1-.865-.865v-3.456c0-.477.387-.865.865-.865H45.49a2.593 2.593 0 0 1 2.593 2.593Zm-26.79-.864v1.728H45.49a.864.864 0 0 0 0-1.728H21.293Z" />
        <path d="M21.293 175.595v-17.284c0-.917.364-1.796 1.013-2.444a3.453 3.453 0 0 1 4.887 0 3.452 3.452 0 0 1 1.013 2.444v2.593a.864.864 0 0 0 1.729 0v-2.593a5.188 5.188 0 0 0-1.519-3.667 5.189 5.189 0 0 0-7.333 0 5.188 5.188 0 0 0-1.519 3.667v17.284a.864.864 0 0 0 1.729 0ZM28.206 173.002v2.593a.864.864 0 0 0 1.729 0v-2.593a.864.864 0 0 0-1.729 0ZM40.305 165.225v3.456a.865.865 0 0 0 1.728 0v-3.456a.865.865 0 0 0-1.728 0ZM35.12 165.225v3.456a.865.865 0 0 0 1.728 0v-3.456a.865.865 0 0 0-1.728 0ZM29.935 165.225v3.456a.865.865 0 0 0 1.728 0v-3.456a.865.865 0 0 0-1.728 0Z" />
        <path d="M24.75 165.225v3.456a.865.865 0 0 0 1.728 0v-3.456a.865.865 0 0 0-1.729 0Z" />
      </g>
      <g filter="url(#g)">
        <path
          d="M143.897 33.109h-43.058a9.026 9.026 0 0 0-9.037 9.036v30.192a9.036 9.036 0 0 0 9.037 9.046h33.86l9.587 7.301v-7.32a9.04 9.04 0 0 0 8.638-9.027V42.145a9.014 9.014 0 0 0-2.64-6.389 9.035 9.035 0 0 0-6.387-2.647Z"
          fill="#fff"
        />
      </g>
      <g
        clipPath="url(#h)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      >
        <path d="m108.683 54.179 3.089-5.15a4.896 4.896 0 0 1 4.196-2.375h8.856c1.718 0 3.311.902 4.196 2.375l3.089 5.15h3.335a4.516 4.516 0 0 1 4.516 4.516v5.266a.753.753 0 0 1-.752.752h-5.267a.753.753 0 1 1 0-1.505h4.514v-4.513a3.014 3.014 0 0 0-3.011-3.011h-3.761a.751.751 0 0 1-.645-.366l-3.308-5.514a3.39 3.39 0 0 0-2.906-1.645h-8.856a3.39 3.39 0 0 0-2.906 1.645l-3.308 5.514a.751.751 0 0 1-.645.366h-3.027a.731.731 0 0 0-.519.216.731.731 0 0 0-.216.52v6.788h3.009a.753.753 0 1 1 0 1.505h-3.762a.753.753 0 0 1-.752-.752v-7.542a2.244 2.244 0 0 1 2.24-2.24h2.601Z" />
        <path d="M111.366 60.198a3.763 3.763 0 0 0 0 7.525 3.764 3.764 0 0 0 3.763-3.762 3.764 3.764 0 0 0-3.763-3.763Zm0 1.505a2.259 2.259 0 0 1 2.258 2.258 2.258 2.258 0 1 1-2.258-2.257ZM130.931 60.198a3.764 3.764 0 0 0-3.763 3.763 3.763 3.763 0 1 0 3.763-3.762Zm0 1.505a2.258 2.258 0 1 1-.002 4.516 2.258 2.258 0 0 1 .002-4.516Z" />
        <path d="M114.376 64.713h13.545a.753.753 0 0 0 0-1.504h-13.545a.753.753 0 0 0 0 1.504ZM131.683 54.179h-18.812a.753.753 0 0 0 0 1.505h18.812a.753.753 0 0 0 0-1.505Z" />
        <path d="M121.901 54.93v-4.514a.753.753 0 0 0-1.505 0v4.515a.753.753 0 0 0 1.505 0ZM138.456 57.188h-1.505a.753.753 0 1 0 0 1.505h1.505a.753.753 0 0 0 0-1.505ZM108.356 59.446h.753a.753.753 0 0 0 0-1.505h-.753a.753.753 0 0 0 0 1.505Z" />
      </g>
      <path
        d="M41.734 238.58a12.155 12.155 0 0 1 6.276 7.103 21.508 21.508 0 0 1 .828 9.632c-.708 6.245-4.26 12.551-8.082 17.548-5.267-4.591-6.471-12.597-6.832-16.705-.572-6.487 2.347-18.541 7.81-17.578ZM46.866 283.171a10.321 10.321 0 0 1 3.341-9.812 13.641 13.641 0 0 1 10.114-3.16 5.786 5.786 0 0 1 4.515 1.986 4.517 4.517 0 0 1 0 4.515 9.031 9.031 0 0 1-3.311 3.266c-4.515 2.859-9.497 4.786-14.659 3.235"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      />
      <path
        d="M40.124 302.329c.029-.43.09-.857.18-1.279.166-.903.392-2.062.648-3.461a35.885 35.885 0 0 1 3.582-11.092 22.19 22.19 0 0 1 7.946-8.457 15.387 15.387 0 0 1 3.25-1.43c.392-.136.723-.181.934-.241.109-.02.221-.02.33 0a24.076 24.076 0 0 0-4.349 2.002 22.761 22.761 0 0 0-7.72 8.397 38.821 38.821 0 0 0-3.657 10.926 113.826 113.826 0 0 1-.783 3.447c-.08.407-.2.805-.36 1.188Z"
        fill="#222"
      />
      <path
        d="M40.32 247.971c.028.184.028.372 0 .557 0 .406 0 .948.105 1.61.075 1.399.15 3.416.24 5.929.151 4.997.287 11.92.257 19.565a527.258 527.258 0 0 1-.437 19.564c-.09 2.513-.195 4.515-.286 5.93 0 .662 0 1.188-.105 1.61.021.185.021.372 0 .557a3.178 3.178 0 0 1 0-.557v-1.61c0-1.505.09-3.477.15-5.93.12-5.011.256-11.919.286-19.564.03-7.645 0-14.553-.12-19.565 0-2.453 0-4.515-.09-5.929v-1.656a3.822 3.822 0 0 1 0-.511Z"
        fill="#222"
      />
      <path
        d="M37.761 286.979a24.162 24.162 0 0 0-13.183-17.698c-1.76-.843-4.063-1.4-5.508-.09-1.445 1.309-1.114 3.672-.407 5.478a20.615 20.615 0 0 0 18.978 12.822"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      />
      <path
        d="M25.42 275.21a5.26 5.26 0 0 1 1.13.482c.43.198.848.424 1.249.677.556.304 1.094.641 1.61 1.009a27.179 27.179 0 0 1 3.792 3.16 24.77 24.77 0 0 1 6.17 10.309c.241.888.482 1.746.618 2.558.15.756.255 1.52.316 2.288.09.692 0 1.339.09 1.896.025.476.025.953 0 1.43a6.546 6.546 0 0 1-.135 1.204c-.106 0 .075-1.731-.241-4.515a19.665 19.665 0 0 0-.361-2.242 22.93 22.93 0 0 0-.647-2.514 27.095 27.095 0 0 0-2.439-5.433 28.417 28.417 0 0 0-3.626-4.71 25.315 25.315 0 0 0-1.897-1.776 22.05 22.05 0 0 0-1.776-1.415c-2.302-1.595-3.897-2.317-3.852-2.408Z"
        fill="#222"
      />
      <defs>
        <clipPath id="b">
          <path
            fill="#fff"
            transform="translate(117.386 115.881)"
            d="M0 0h54.178v54.178H0z"
          />
        </clipPath>
        <clipPath id="d">
          <path
            fill="#fff"
            transform="translate(100.832 209.188)"
            d="M0 0h37.624v37.624H0z"
          />
        </clipPath>
        <clipPath id="f">
          <path
            fill="#fff"
            transform="translate(19.564 144.476)"
            d="M0 0h40.634v40.634H0z"
          />
        </clipPath>
        <clipPath id="h">
          <path
            fill="#fff"
            transform="translate(103.842 39.129)"
            d="M0 0h36.119v36.119H0z"
          />
        </clipPath>
        <filter
          id="a"
          x={103.347}
          y={108.361}
          width={82.266}
          height={75.183}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.5} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1627_10135"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.5} />
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0" />
          <feBlend
            in2="effect1_dropShadow_1627_10135"
            result="effect2_dropShadow_1627_10135"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1627_10135"
            result="shape"
          />
        </filter>
        <filter
          id="c"
          x={86.728}
          y={201.668}
          width={65.767}
          height={60.172}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.5} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1627_10135"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.5} />
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0" />
          <feBlend
            in2="effect1_dropShadow_1627_10135"
            result="effect2_dropShadow_1627_10135"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1627_10135"
            result="shape"
          />
        </filter>
        <filter
          id="e"
          x={5.525}
          y={136.956}
          width={69.067}
          height={63.197}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.5} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1627_10135"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.5} />
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0" />
          <feBlend
            in2="effect1_dropShadow_1627_10135"
            result="effect2_dropShadow_1627_10135"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1627_10135"
            result="shape"
          />
        </filter>
        <filter
          id="g"
          x={89.802}
          y={31.609}
          width={65.122}
          height={59.575}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.5} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1627_10135"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.5} />
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0" />
          <feBlend
            in2="effect1_dropShadow_1627_10135"
            result="effect2_dropShadow_1627_10135"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1627_10135"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default IllustrationMobility;
